import {
  Pressable,
  StyleSheet,
  Text,
  TextInput,
  View,
  Platform,
} from "react-native";
import NavBar from "../../components/NavBar";
import {
  color_main,
  color_BEBEBE,
  color_333333,
  color_EEF3FA,
  black,
  ColorLine,
} from "../../assets/style/colors";
import { MainNavProps } from "../navigation/main/MainParamList";
import React, { useEffect, useState } from "react";
import { qryProblem, securityProblem } from "../../net/service";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import BaseScreen from "../BaseScreen";
import {
  Str_Answer,
  Str_AnswerNotNull,
  Str_Complete,
  Str_OpenSecurityLoading,
  Str_OpenSecurityTitle,
  Str_PlaceholderAnswer,
  Str_PlaceholderProblem,
  Str_Problem,
  Str_ProblemNotNull,
  Str_SetFail,
  Str_SetSuc,
  Str_Skip,
} from "../../language/string_res";
import { AuthNavProps } from "../navigation/auth/AuthParamList";
import { useIsFocused } from "@react-navigation/native";
import { SecurityProblemRequestData } from "../../net/request";
import { CryptEngine } from "../../utils/CryptEngine";
import { getLanguage } from "../../language/i18n";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";

export function OpenSecurity({
  navigation,
  route,
}: MainNavProps<"OpenSecurity"> & AuthNavProps<"OpenSecurity">) {
  const from = route.params.from;
  const psd = route.params.psd;
  const vcode = route.params.vcode;
  const [problem, setProblem] = useState("");
  const [answer, setAnswer] = useState("");
  const account = route.params.account;
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused && from === "setting") {
      qryProblem().then((res) => {
        if (res && res.data) {
          setProblem(res.data.security_problem);
          setAnswer(res.data.security_answer);
        }
      });
    }
  }, [isFocused]);

  function submit() {
    if (problem.trim().length <= 0) {
      showToast(Str_ProblemNotNull);
      return;
    }
    if (answer.trim().length <= 0) {
      showToast(Str_AnswerNotNull);
      return;
    }
    showLoading(Str_OpenSecurityLoading);
    const body: SecurityProblemRequestData = {
      account: account.trim(),
      lang: getLanguage(),
      security_problem: problem.trim(),
      security_answer: answer.trim(),
      vcode: vcode,
    };
    if (psd) {
      body.passwd = CryptEngine.base64Encode(psd.trim());
    }
    securityProblem(body)
      .then((res) => {
        if (res.code === 0) {
          showToast(Str_SetSuc);
          back();
        } else {
          showToast(res.msg || Str_SetFail);
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  function back() {
    if (from === "register") {
      navigation.navigate("Login", { vcode: vcode });
    } else {
      navigation.goBack();
    }
  }

  return (
    <ScreenCloseModal title={Str_OpenSecurityTitle}>
      <View style={styles.webFormContainer}>
        <View style={styles.webFormField}>
          <Text style={styles.webLabel}>{Str_Problem}</Text>
          <View style={styles.webInputWrapper}>
            <TextInput
              placeholder={Str_PlaceholderProblem}
              editable={true}
              focusable={true}
              selectionColor={color_main}
              placeholderTextColor={color_BEBEBE}
              style={styles.webInput}
              value={problem}
              onChangeText={(text) => {
                setProblem(text);
              }}
            />
          </View>
        </View>

        <View style={styles.webFormField}>
          <Text style={styles.webLabel}>{Str_Answer}</Text>
          <View style={styles.webInputWrapper}>
            <TextInput
              placeholder={Str_PlaceholderAnswer}
              editable={true}
              focusable={true}
              selectionColor={color_main}
              placeholderTextColor={color_BEBEBE}
              style={styles.webInput}
              value={answer}
              onChangeText={(text) => {
                setAnswer(text);
              }}
            />
          </View>
        </View>

        {from === "register" && (
          <Pressable onPress={back} style={styles.skipButton}>
            <Text style={styles.skipButtonText}>{Str_Skip}</Text>
          </Pressable>
        )}

        <Pressable
          onPress={submit}
          style={[
            styles.submitButton,
            { marginTop: from === "register" ? 16 : 8 },
          ]}
        >
          <Text style={styles.submitButtonText}>{Str_Complete}</Text>
        </Pressable>
      </View>
    </ScreenCloseModal>
  );
}

const styles = StyleSheet.create({
  webFormContainer: {
    paddingHorizontal: 24,
    paddingTop: 24,
    flex: 1,
    width: "100%",
    ...(Platform.OS === "web" && {
      maxWidth: 600,
      alignSelf: "center",
      paddingHorizontal: 40,
      paddingTop: 60,
      paddingBottom: 60,
    }),
  },
  // Web 表单字段
  webFormField: {
    marginBottom: 24,
  },
  // Web 标签样式
  webLabel: {
    color: black,
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 8,
  },
  // Web 输入框包装器
  webInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E0E0E0",
    borderRadius: 8,
    paddingHorizontal: 16,
    minHeight: 48,
    backgroundColor: "white",
    ...(Platform.OS === "web" && {
      transition: "border-color 0.2s",
    }),
  },
  // Web 输入框样式
  webInput: {
    flex: 1,
    height: 48,
    color: color_333333,
    fontSize: 16,
  },
  // 移动端标签样式
  mobileLabel: {
    color: black,
    fontSize: 16,
    fontWeight: "500",
  },
  // 移动端输入框容器
  inputBg: {
    flexDirection: "row",
    alignItems: "center",
    height: 72,
    marginHorizontal: 20,
    paddingHorizontal: 16,
    minHeight: 56,
  },
  // 移动端输入框样式
  input: {
    height: 48,
    flex: 1,
    color: color_333333,
    marginStart: 16,
    fontSize: 16,
  },
  // 跳过按钮样式
  skipButton: {
    marginTop: 8,
    backgroundColor: color_EEF3FA,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 32,
    minWidth: 120,
    alignItems: "center",
    justifyContent: "center",
    ...(Platform.OS === "web" && {
      cursor: "pointer",
      userSelect: "none",
      transition: "opacity 0.2s, background-color 0.2s",
    }),
  },
  skipButtonText: {
    color: color_333333,
    fontSize: 16,
    fontWeight: "600",
  },
  // 提交按钮样式（更宽）
  submitButton: {
    backgroundColor: color_main,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 48,
    minWidth: 200,
    alignItems: "center",
    justifyContent: "center",
    ...(Platform.OS === "web" && {
      cursor: "pointer",
      userSelect: "none",
      transition: "opacity 0.2s, background-color 0.2s",
    }),
  },
  submitButtonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "600",
  },
});
